<template>
    <div class="drag_guide" v-if="isShow" :style="styleString"/>
</template>


<script>
import { columnWidth } from './column-width'
export default {
    props: {
        scroll: HTMLDivElement,
    },
    data() {
        return {
            columnWidth
        }
    },
    computed: {
        isShow: function() { return this.columnWidth.isResizing },
        xPosition: function() {
            let parentRect = this.scroll?.getBoundingClientRect()
            let parentX = parentRect?.x ?? 0
            return this.columnWidth.guideX - parentX + this.scroll?.scrollLeft
        },
        scrollHeight: function() { return this.scroll.scrollHeight },
        styleString: function() { return 'left: ' + this.xPosition + 'px; ' + 'height: ' + this.scrollHeight + 'px;' }
    }
}
</script>


<style scoped>
    .drag_guide{
        position: absolute;
        width: 1px;
        background-color:var(--gray80);
        z-index: 100;
    }
</style>